// Angular
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
// Local service
import { AlertService } from "../../services/alert.service";
import { ClienteService } from "../../services/cliente.service";
// 3rd libraries
import swal from "sweetalert2";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonFunctions } from "../../utils/common-functions";

@Component({
  selector: "app-gestiones-actualizar-ingresos",
  templateUrl: "./gestiones-actualizar-ingresos.component.html",
  styleUrls: ["./gestiones-actualizar-ingresos.component.scss"],
})
export class GestionesActualizarIngresosComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Input() clienteserviceParam: ClienteService;
  @Input() datacliente: any;
  cargaindicesbool = false;
  ingresosydeducciones: any = {};
  clientData: any = {};
  @Output() setDataCliente = new EventEmitter<any>();
  precalificationData: any = {};
  formatterDecimal = new Intl.NumberFormat("es-GT", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: "decimal",
  });
  constructor(
    private alertService: AlertService,
    private ngxUiLoaderService: NgxUiLoaderService
  ) {
    setTimeout(() => {
      if(this.precalificationData.codigoSegmentoRiesgoPagoVoluntario=="I"){
        this.showNotification('Alerta','Recuerda Ingresar el Salario sin Sensibilizar')
      }
      this.autocompleteIngresos();
    }, 500);
  }

  ngOnInit(): void {
    this.clientData =
      this.clienteserviceParam.flowType === "DEBTOR"
        ? this.clienteserviceParam.datosCliente
        : this.clienteserviceParam.datosCodeudor;
    this.precalificationData =
      this.clienteserviceParam.flowType === "DEBTOR"
        ? this.clienteserviceParam.datosPrecalificacion
        : this.clienteserviceParam.datosPrecalificacionCodeudor;
  }
  goToConsolidar() {
    if (
      this.ingresosydeducciones.salarioBase == null ||
      this.ingresosydeducciones.salarioBase === ""||
      this.ingresosydeducciones.salarioBase === 0 ||
      this.ingresosydeducciones.salarioBase === "0" ||
      this.ingresosydeducciones.salarioBase === "0.00"
    ) {
      this.showNotification("Alerta", "El salario debe ser mayor a cero.");
    } else {
      this.ingresosydeducciones.bonificaciones =
        this.ingresosydeducciones.bonificaciones !== null
          ? this.ingresosydeducciones.bonificaciones
          : "0";
      this.ingresosydeducciones.comisiones =
        this.ingresosydeducciones.comisiones !== null
          ? this.ingresosydeducciones.comisiones
          : "0";
      this.ingresosydeducciones.otrosIngresos =
        this.ingresosydeducciones.otrosIngresos !== null
          ? this.ingresosydeducciones.otrosIngresos
          : "0";
      this.ingresosydeducciones.igss =
        this.ingresosydeducciones.igss !== null
          ? this.ingresosydeducciones.igss
          : "0";
      this.ingresosydeducciones.isr =
        this.ingresosydeducciones.isr != null
          ? this.ingresosydeducciones.isr
          : "0";
      this.ingresosydeducciones.judiciales =
        this.ingresosydeducciones.judiciales !== null
          ? this.ingresosydeducciones.judiciales
          : "0";
      this.ingresosydeducciones.otrasDeducciones =
        this.ingresosydeducciones.otrasDeducciones !== null
          ? this.ingresosydeducciones.otrasDeducciones
          : "0";
      this.ingresosydeducciones.cuotaBancoIndice =
        this.ingresosydeducciones.cuotaBancoIndice !== null
          ? this.ingresosydeducciones.cuotaBancoIndice
          : "0";
      this.ingresosydeducciones.salarioLiquidoBT =
        this.ingresosydeducciones.salarioLiquidoBT !== null
          ? this.ingresosydeducciones.salarioLiquidoBT
          : "0";
      this.clienteserviceParam.setIngresosyDedudcciones(
        this.ingresosydeducciones
      );
      this.validateCustomer(
        this.clientData.isNewExistClient
          ? this.clientData.isNewExistClient
          : false
      );
    }
  }
  transformAmount(element) {
    element.target.value = this.formatterDecimal.format(
      element.target.value.toString().replace(",", "")
    );
  }
  goBack() {
    this.clientData.datosIndice.isBack = true;
    this.clienteserviceParam.datosPrecalificacion.ingresosydeducciones=null
    this.selecttab.emit(15);
  }

  validateCustomer(isNewClient: any) {
    this.ngxUiLoaderService.startLoader("loader-global", "loadingDashboard");
    if(this.clienteserviceParam.rolVerificacionFlag){
      this.selecttab.emit(16);
    }else{
      this.clienteserviceParam
      .validateCustomerAcceptanceCriteria(isNewClient)
      .subscribe(
        (result) => {
          const data = result;
          // @ts-ignore
          if (data.codigo !== 2 && data.Respuesta !== null) {
            // @ts-ignore
            const acceptanceCriteria = data.Respuesta.criterioAcpetacion;
            if (acceptanceCriteria && acceptanceCriteria.length > 0) {
              const criteria = acceptanceCriteria.find(
                (item) => item.tipoParticipante === "DEUDOR"
              );
              if (criteria) {
                if (criteria.outCriterioValidacionPrecalificacionFlg === "N") {
                  this.ngxUiLoaderService.stopLoader(
                    "loader-global",
                    "loadingDashboard"
                  );
                  const message =
                    criteria.outCriterioValidacionPrecalificacionMsj;
                  const list = message.split("/ ");
                  if (list.length > 0) {
                    const title = `<strong>${list[0]}</strong>`;
                    let text = "";
                    list.forEach((item, index) => {
                      if (index !== 0) {
                        text = text + `<span>${item}</span><br>`;
                      }
                    });
                    if (this.clienteserviceParam.flowType === "DEBTOR") {
                      this.alertService.show(title, text).then();
                      this.selecttab.emit(0);
                    } else {
                      this.alertService
                        .confirmationHMTL(
                          `<strong>Codeudor no aplica por los siguientes criterios:</strong>`,
                          (text =
                            text +
                            `<span>Para continuar, deber agregar otro codeudor</span><br>`),
                          "Continuar"
                        )
                        .then((confirm) => {
                          if (confirm.isConfirmed) {
                            this.showDpiAlert();
                          } else {
                            this.clienteserviceParam.datosPrecalificacionCodeudor =
                              {};
                            this.clienteserviceParam.commonCredits = [];
                            this.clienteserviceParam
                              .rejectCoDebtorFlow()
                              .then(() => {
                                this.selecttab.emit(11);
                              });
                          }
                        });
                    }
                  }
                } else {
                  if(this.clienteserviceParam.rolABFlag){//si es flujo agentes bancarios
                    this.ngxUiLoaderService.stopLoader(
                      "loader-global",
                      "loadingDashboard"
                    );
                    this.selecttab.emit(20);
                  }else{
                    this.selecttab.emit(16); 
                  }
                }
              } else {
                this.showNotification(
                  "Alerta",
                  "Ha ocurrido un error, intente más tarde."
                );
              }
            } else {
              this.showNotification(
                "Alerta",
                "Ha ocurrido un error, intente más tarde."
              );
            }
          } else {
            this.showNotification(
              "Alerta",
              "Ha ocurrido un error, intente más tarde."
            );
            this.ngxUiLoaderService.stopLoader(
              "loader-global",
              "loadingDashboard"
            );
          }
        },
        (error) => {
          this.showNotification(
            "Alerta",
            "Ha ocurrido un error, intente más tarde."
          );
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
        }
      );
    }
  }

  autocompleteIngresos() {
    this.ingresosydeducciones.bonificaciones = "0.00";
    this.ingresosydeducciones.comisiones = "0.00";
    this.ingresosydeducciones.otrosIngresos = "0.00";
    this.ingresosydeducciones.otrasDeducciones = "0.00";
    this.ingresosydeducciones.salarioBase = "0.00";
    this.ingresosydeducciones.salarioLiquidoBT = "0.00";
    this.ingresosydeducciones.cuotaBancoIndice = "0.00";
    this.ingresosydeducciones.judiciales = "0.00";
    const position = this.clientData.datosIndice.position
      ? this.clientData.datosIndice.position
      : 0;
    if (this.clientData.cliente.nombreCompleto != null) {
      if (
        this.precalificationData.ingresosydeducciones
      ) {
        this.ingresosydeducciones =
          this.precalificationData.ingresosydeducciones;
        if (this.clientData.datosIndice.clienteDatosIndice.length > 0) {
          this.cargaindicesbool = true;
        }
      } else {
        this.ingresosydeducciones.salarioBase = "0.00";
        if (
          this.clientData.cliente.existeEmpleadoGobierno === "S" &&
          this.precalificationData.segmento === "E" &&
          !this.clienteserviceParam.manualEntry
        ) {
          if (this.clientData.datosIndice.clienteDatosIndice.length > 0) {
            this.ingresosydeducciones.salarioBase =
              this.clientData.datosIndice.clienteDatosIndice[position]
                .salarioNominal === ""
                ? "0.00"
                : this.clientData.datosIndice.clienteDatosIndice[position]
                    .salarioNominal;
            this.ingresosydeducciones.salarioLiquidoBT =
              this.clientData.datosIndice.clienteDatosIndice[position]
                .salarioLiquido === ""
                ? "0.00"
                : this.clientData.datosIndice.clienteDatosIndice[position]
                    .salarioLiquido;
            this.ingresosydeducciones.cuotaBancoIndice =
              this.clientData.datosIndice.clienteDatosIndice[position]
                .valorDescuentoCuotaBantrab === ""
                ? "0.00"
                : this.clientData.datosIndice.clienteDatosIndice[position]
                    .valorDescuentoCuotaBantrab;
            this.ingresosydeducciones.judiciales =
              this.clientData.datosIndice.clienteDatosIndice[position]
                .valorDescuentoJudicial === ""
                ? "0.00"
                : this.clientData.datosIndice.clienteDatosIndice[position]
                    .valorDescuentoJudicial;
            this.ingresosydeducciones.judiciales =
              +this.ingresosydeducciones.judiciales === 0
                ? "0.00"
                : this.ingresosydeducciones.judiciales;
            this.cargaindicesbool = true;
          }
        } else {
          this.ingresosydeducciones.salarioBase = "0.00";
        }
        if (this.precalificationData.datosPatrono.codigoPatrono === "46001"||this.precalificationData.codigoSegmentoRiesgoPagoVoluntario=="I"||this.precalificationData.codigoSegmentoRiesgoPagoVoluntario=="S") {
          this.ingresosydeducciones.igss = "0.00";
          this.ingresosydeducciones.isr = "0.00";
        } else {
            this.ingresosydeducciones.igss = this.formatterDecimal
            .format(
              Number(
                this.clienteserviceParam.getvalorDecimales(
                  this.ingresosydeducciones.salarioBase
                )
              ) * 0.0483
            )
            .toString();          
          this.ingresosydeducciones.isr = this.formatterDecimal
            .format(
              Number(
                this.clienteserviceParam.getvalorDecimales(
                  this.ingresosydeducciones.salarioBase
                )
              ) * 0.0517
            )
            .toString();
        }
      }
    }
  }

  addExtraInfo() {
    if (
      this.precalificationData.segmento === "P" ||
      this.clienteserviceParam.manualEntry === true ||
      this.clientData.datosIndice.clienteDatosIndice.length === 0
    ) {
      if (this.clientData.cliente.existeClienteActualizado === "S") {
        // this.ingresosydeducciones.salarioBase =  this.clientData.cliente.ultimoTotalIngresosRerportado;
        this.ingresosydeducciones.salarioBase = "0.00";
        if (this.clientData.informacionAdicional.length > 0) {
          if (
            this.clientData.informacionAdicional.find(
              (i) => i.nombreRegistrado === "Bonificaciones"
            ) != null
          ) {
            if (
              this.clientData.informacionAdicional.find(
                (i) => i.nombreRegistrado === "Bonificaciones"
              ).montoRegistrado === ".00"
            ) {
              this.ingresosydeducciones.bonificaciones = "0.00";
            } else {
              this.ingresosydeducciones.bonificaciones =
                this.clientData.informacionAdicional.find(
                  (i) => i.nombreRegistrado === "Bonificaciones"
                ).montoRegistrado;
            }
          }
          if (
            this.clientData.informacionAdicional.find(
              (i) => i.nombreRegistrado === "Comisiones"
            ) != null
          ) {
            if (
              this.clientData.informacionAdicional.find(
                (i) => i.nombreRegistrado === "Comisiones"
              ).montoRegistrado === ".00"
            ) {
              this.ingresosydeducciones.comisiones = "0.00";
            } else {
              this.ingresosydeducciones.comisiones =
                this.clientData.informacionAdicional.find(
                  (i) => i.nombreRegistrado === "Comisiones"
                ).montoRegistrado;
            }
          }
          if (
            this.clientData.informacionAdicional.find(
              (i) => i.nombreRegistrado === "Otros"
            ) != null
          ) {
            if (
              this.clientData.informacionAdicional.find(
                (i) => i.nombreRegistrado === "Otros"
              ).montoRegistrado === ".00"
            ) {
              this.ingresosydeducciones.otrosIngresos = "0.00";
            } else {
              this.ingresosydeducciones.otrosIngresos =
                this.clientData.informacionAdicional.find(
                  (i) => i.nombreRegistrado === "Otros"
                ).montoRegistrado;
            }
          }
          if (
            this.clientData.informacionAdicional.find(
              (i) => i.nombreRegistrado === "Otras"
            ) != null
          ) {
            if (
              this.clientData.informacionAdicional.find(
                (i) => i.nombreRegistrado === "Otras"
              ).montoRegistrado === ".00"
            ) {
              this.ingresosydeducciones.otrasDeducciones = "0.00";
            } else {
              this.ingresosydeducciones.otrasDeducciones =
                this.clientData.informacionAdicional.find(
                  (i) => i.nombreRegistrado === "Otras"
                ).montoRegistrado;
            }
          }
        }
      }
    }
  }

  changeIngresos(element) {
    element.target.value = this.formatterDecimal.format(
      element.target.value.toString().replace(",", "")
    );
    if (this.precalificationData.datosPatrono.codigoPatrono != "46001"&& this.precalificationData.codigoSegmentoRiesgoPagoVoluntario!="I"&& this.precalificationData.codigoSegmentoRiesgoPagoVoluntario!="S") {
        this.ingresosydeducciones.igss = this.formatterDecimal
        .format(
          Number(
            this.clienteserviceParam.getvalorDecimales(
              this.ingresosydeducciones.salarioBase
            )
          ) * 0.0483
        )
        .toString();
      
      this.ingresosydeducciones.isr = this.formatterDecimal
        .format(
          Number(
            this.clienteserviceParam.getvalorDecimales(
              this.ingresosydeducciones.salarioBase
            )
          ) * 0.0517
        )
        .toString();
    }
  }
  showNotification(title, message) {
    swal
      .fire({
        title: title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {});
  }

  showNotificationsinoferta(title, message) {
    swal
      .fire({
        title: title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {
        this.selecttab.emit(0);
      });
  }

  showDpiAlert() {
    const dpi = "";
    swal
      .fire({
        title: "Ingrese el DPI del codeudor",
        input: "text",
        inputLabel: "DPI",
        inputValue: dpi,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        inputValidator: (result) =>
          (!result && "Por favor ingrese un número de DPI.") ||
          (result.length !== 13 &&
            "El número de DPI no es válido, favor verifique.") ||
          (result === this.clienteserviceParam.datosCliente.cliente.dpi &&
            "El numero de DPI ingresado no puede ser igual al de deudor"),
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        confirmButtonText: "Continuar",
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.clienteserviceParam.datosPrecalificacionCodeudor = {};
          this.clienteserviceParam.commonCredits = [];
          this.ngxUiLoaderService.startLoader(
            "loader-global",
            "loadingDashboard"
          );
          this.setDataCliente.emit({
            dpi: result.value,
            flowType: "CODEBTOR",
          });
        }
      });
  }
}
